/* JAYKEI footer: pop the social icons in one by one when the footer is reached. */
(function () {
  'use strict';


  /* Wavy-cloth hover on the embroidered wordmark. A rippled copy of the image is
     revealed through a soft circular mask that tracks the pointer, so only the
     area under the cursor moves. The filter is attached only while animating and
     the rAF loop stops once it settles, so there is no idle cost. */
  function initCloth() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    document.querySelectorAll('[data-cloth]').forEach(function (host) {
      if (host.dataset.clothInit === '1') return;
      var filter = document.getElementById(host.dataset.cloth);
      var warp = host.querySelector('.jk-footer__wm--warp');
      if (!filter || !warp) return;
      host.dataset.clothInit = '1';

      var disp = filter.querySelector('feDisplacementMap');
      var turb = filter.querySelector('feTurbulence');
      var raf = null, t = 0, cur = 0, target = 0;

      function frame() {
        t += 0.016;
        cur += (target - cur) * 0.09;
        disp.setAttribute('scale', cur.toFixed(2));
        // drift the noise so the ripple travels rather than sitting still
        var bx = 0.013 + Math.sin(t * 0.9) * 0.003;
        var by = 0.030 + Math.cos(t * 0.6) * 0.005;
        turb.setAttribute('baseFrequency', bx.toFixed(4) + ' ' + by.toFixed(4));

        if (target === 0 && cur < 0.12) {
          disp.setAttribute('scale', '0');
          warp.style.filter = '';
          raf = null;
          return;
        }
        raf = window.requestAnimationFrame(frame);
      }
      function start() { if (!raf) raf = window.requestAnimationFrame(frame); }

      host.addEventListener('mousemove', function (e) {
        var r = host.getBoundingClientRect();
        host.style.setProperty('--jk-mx', (e.clientX - r.left).toFixed(0) + 'px');
        host.style.setProperty('--jk-my', (e.clientY - r.top).toFixed(0) + 'px');
      });
      host.addEventListener('mouseenter', function () {
        target = 11;                      // displacement strength: 17 was too strong, 7 too faint
        warp.style.filter = 'url(#' + filter.id + ')';
        host.classList.add('is-waving');
        start();
      });
      host.addEventListener('mouseleave', function () {
        target = 0;
        host.classList.remove('is-waving');
        start();
      });
    });
  }

  function init() {
    initCloth();
    document.querySelectorAll('.jk-footer__social').forEach(function (group) {
      if (group.dataset.anim === 'ready') return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) {
        group.classList.add('is-in');   // no animation, just show them
        return;
      }

      // Only hide them once we know we can reveal them again.
      group.dataset.anim = 'ready';

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);     // play once
        });
      }, { threshold: 0.4, rootMargin: '0px 0px -40px 0px' });

      io.observe(group);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
